import {
  // People & Groups
  Users,
  User,
  UserCircle,
  UsersRound,
  // Nature & Weather
  Flame,
  Sun,
  Moon,
  Cloud,
  Snowflake,
  Droplet,
  Wind,
  Mountain,
  Trees,
  Flower2,
  Leaf,
  // Space & Sky
  Star,
  Sparkles,
  Rocket,
  Plane,
  Globe,
  Orbit,
  Eclipse,
  // Objects & Symbols
  Zap,
  Target,
  Shield,
  Crown,
  Trophy,
  Heart,
  Compass,
  Flag,
  Anchor,
  Key,
  Lock,
  Gem,
  Diamond,
  // Animals
  Bird,
  Bug,
  Fish,
  Cat,
  Dog,
  Rabbit,
  Turtle,
  Squirrel,
  // Activities & Sports
  Bike,
  Dumbbell,
  Swords,
  Crosshair,
  Gamepad2,
  Dice5,
  // Music & Arts
  Music,
  Palette,
  Brush,
  Camera,
  Film,
  // Tech & Gaming
  Cpu,
  Bot,
  Ghost,
  Skull,
  // Food & Drink
  Pizza,
  Coffee,
  IceCream2,
  Cherry,
  Apple,
  Banana,
  Cake,
  // Misc Fun
  PartyPopper,
  Gift,
  Candy,
  Puzzle,
  Lightbulb,
  Eye,
  Glasses,
  Smile,
  Laugh,
  type LucideIcon,
} from 'lucide-react';

/**
 * Maps icon name strings to Lucide icon components
 * Used for rendering team icons dynamically based on stored icon name
 */
const TEAM_ICONS: Record<string, LucideIcon> = {
  // People & Groups
  users: Users,
  user: User,
  'user-circle': UserCircle,
  'users-round': UsersRound,
  // Nature & Weather
  flame: Flame,
  sun: Sun,
  moon: Moon,
  cloud: Cloud,
  snowflake: Snowflake,
  droplet: Droplet,
  wind: Wind,
  mountain: Mountain,
  trees: Trees,
  flower: Flower2,
  leaf: Leaf,
  // Space & Sky
  star: Star,
  sparkles: Sparkles,
  rocket: Rocket,
  plane: Plane,
  globe: Globe,
  orbit: Orbit,
  eclipse: Eclipse,
  // Objects & Symbols
  zap: Zap,
  target: Target,
  shield: Shield,
  crown: Crown,
  trophy: Trophy,
  heart: Heart,
  compass: Compass,
  flag: Flag,
  anchor: Anchor,
  key: Key,
  lock: Lock,
  gem: Gem,
  diamond: Diamond,
  // Animals
  bird: Bird,
  bug: Bug,
  fish: Fish,
  cat: Cat,
  dog: Dog,
  rabbit: Rabbit,
  turtle: Turtle,
  squirrel: Squirrel,
  // Activities & Sports
  bike: Bike,
  dumbbell: Dumbbell,
  swords: Swords,
  crosshair: Crosshair,
  gamepad: Gamepad2,
  dice: Dice5,
  // Music & Arts
  music: Music,
  palette: Palette,
  brush: Brush,
  camera: Camera,
  film: Film,
  // Tech & Gaming
  cpu: Cpu,
  bot: Bot,
  ghost: Ghost,
  skull: Skull,
  // Food & Drink
  pizza: Pizza,
  coffee: Coffee,
  'ice-cream': IceCream2,
  cherry: Cherry,
  apple: Apple,
  banana: Banana,
  cake: Cake,
  // Misc Fun
  party: PartyPopper,
  gift: Gift,
  candy: Candy,
  puzzle: Puzzle,
  lightbulb: Lightbulb,
  eye: Eye,
  glasses: Glasses,
  smile: Smile,
  laugh: Laugh,
};

/**
 * Gets a Lucide icon component by name
 * Falls back to Users icon if the name is not found
 */
export function getTeamIcon(name: string | null | undefined): LucideIcon {
  if (!name) return Users;
  return TEAM_ICONS[name.toLowerCase()] || Users;
}

/**
 * List of available team icon options
 */
export const AVAILABLE_TEAM_ICONS = Object.keys(TEAM_ICONS);

/**
 * Fallback swatch when a team (or its activity row) has no icon color
 * yet — brand primary blue, shared by every surface that renders team
 * avatars so the fallback is consistent.
 */
export const DEFAULT_TEAM_ICON_COLOR = '#3B82F6';
